import initialState from './initialState'
import {
    PROCORE_EMBED_HANDSHAKE_REQUEST,
    PROCORE_EMBED_HANDSHAKE_SUCCESS,
    PROCORE_EMBED_HANDSHAKE_FAILURE,
} from '../actions/actionTypes'

/**
 * Tracks the Procore embedded-iframe handshake state. `isEmbedded`
 * stays true for the lifetime of the SPA session so downstream
 * components can hide chrome that doesn't make sense inside Procore.
 */
export default function procoreEmbed(state = initialState.procoreEmbed, action) {
    switch (action.type) {
        case PROCORE_EMBED_HANDSHAKE_REQUEST:
            return { ...state, isEmbedded: true, loading: true, error: null }
        case PROCORE_EMBED_HANDSHAKE_SUCCESS:
            return {
                ...state,
                isEmbedded: true,
                loading: false,
                lobsterProjectId: action.lobsterProjectId || null,
                error: null,
            }
        case PROCORE_EMBED_HANDSHAKE_FAILURE:
            return { ...state, isEmbedded: true, loading: false, error: action.error }
        default:
            return state
    }
}
